import moment from 'moment';

export default function formatDate(time, format = 'DD/MM/YYYY') {
    if (!time) {
        return '-';
    }
    return moment(time).locale('fr').format(format);
}
